/**
 * @author Junaid Atari <mj.atari@gmail.com>
 * @see https://github.com/blacksmoke26/dawn-of-man-generator
 * @since 2024-07-11
 * @version 2.5.0
 */

import React from 'react';

// components
import XmlTextLoader from './loaders/XmlTextLoader';

/** XmlImporter functional component */
const XmlImporter = () => {
	return (
		<>
			<XmlTextLoader/>
		</>
	);
};

export default XmlImporter;
 
